<template>
  <div>
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>
        <span />
      </template>
    </app-breadcrumb>
    <b-row>
      <b-col
        v-if="groupData"
        md="6"
        offset-md="3"
      >
        <!-- Form assign -->
        <b-overlay
          :show="loading"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
          rounded="sm"
        >
          <b-card no-body>
            <b-card-body class="p-1">
              <validation-observer
                ref="formGroupAssign"
                #default="{ handleSubmit }"
              >
                <b-form @submit.prevent="handleSubmit(assignGroupRole)">
                  <!-- Role -->
                  <validation-provider
                    #default="{ errors }"
                    name="Nhóm quyền"
                    rules="required"
                  >
                    <b-form-group>
                      <template #label>
                        <label class="d-block font-weight-bolder pb-0">Cấp vai trò cho nhóm người dùng: {{ groupData.name }}</label>
                      </template>
                      <v-select
                        v-model="assignRoleData.role_id"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="roleOptions"
                        :reduce="(val) => val.id"
                        :state="errors.length > 0 ? false : null"
                        placeholder="--Chọn--"
                        label="name"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                  <div class="mt-2">
                    <b-button
                      variant="primary"
                      type="submit"
                    > {{ $t('Thêm') }} </b-button>
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
          <!-- Table list -->
          <b-overlay
            :show="loadingTable"
            spinner-variant="primary"
            spinner-type="grow"
            spinner-small
            rounded="sm"
          >
            <b-card no-body>
              <b-table
                ref="refGroupRole"
                class="position-relative"
                :items="roleGroupItems"
                primary-key="id"
                responsive
                show-empty
                empty-text="Không tìm thấy kết quả"
                :fields="tableColumns"
              >
                <template #cell(group_id)="row">
                  {{ resolveGroupName(row.item.group_id) }}
                </template>
                <template #cell(role_id)="row">
                  {{ resolveRoleName(row.item.role_id) }}
                </template>
                <template #cell(actions)="row">
                  <b-button
                    v-if="$can('group.assignRole', 'Group')"
                    size="sm"
                    variant="danger"
                    title="Xóa"
                    @click="removeRoleGroup(row.item)"
                  >
                    <span class="text-nowrap">
                      <feather-icon icon="TrashIcon" />
                    </span>
                  </b-button>
                </template>
              </b-table>
            </b-card>
          </b-overlay>
        </b-overlay>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BForm, BFormGroup, BButton, BRow, BCol, BTable, BCardBody,
} from 'bootstrap-vue';
import { ref, reactive } from '@vue/composition-api';
import store from '@/store';
import { useRouter, showToast } from '@core/utils/utils';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  required, alphaNum, alphaNumDot, max, integer,
} from '@validations';
import Ripple from 'vue-ripple-directive';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue';
import vSelect from 'vue-select';
import Queue from '@/libs/queue';
import useGroups from './useGroups';

export default {
  components: {
    AppBreadcrumb,
    BRow,
    BCol,
    BCard,
    BOverlay,
    BForm,
    BFormGroup,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BTable,
    vSelect,
    BCardBody,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      integer,
      alphaNum,
      alphaNumDot,
      max,
    };
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const id = ref(route.value.params.id !== undefined ? route.value.params.id : 0);
    const groupData = ref(null);
    const roleOptions = ref([]);
    const roleGroupItems = ref([]);
    const assignRoleData = reactive({
      role_id: null,
      collection_id: null,
    });
    const loadingTable = ref(false)

    const formGroupAssign = ref(null);

    const tableColumns = [

      {
        key: 'role_id',
        sortable: false,
        label: 'Vai trò',
        thAttr: {},
      },
      {
        key: 'actions',
        sortable: false,
        label: 'Hành động',
        thAttr: { width: '150' },
        tdClass: 'text-center',
      },
    ]

    const { loading } = useGroups();

    const fetchRole = () =>
      // loading.value = true;
      store.dispatch('roles/fetchRoles', { isPaginate: 0 }).then((response) => {
        if (response.status === 200) {
          roleOptions.value = response.data.data;
          // loading.value = false;
        } else {
          // loading.value = false;
        }
      });

    const fetchGroupData = () =>
      // loading.value = true;
      store.dispatch('groups/fetchGroup', { id: id.value }).then((response) => {
        if (response.status === 200) {
          groupData.value = response.data.data;
          // loading.value = false;
        } else {
          // loading.value = false;
        }
      });
    const getGroupRole = () => {
      loading.value = true;
      return store.dispatch('groups/getGroupRole', { id: id.value }).then((response) => {
        if (response.status === 200) {
          roleGroupItems.value = response.data.data;
          loading.value = false;
        } else {
          loading.value = false;
        }
      });
    };

    const assignGroupRole = () => {
      loadingTable.value = false;
      const data = {
        group_id: id.value,
        role_id: assignRoleData.role_id,
        action: 'add',
      }
      store.dispatch('groups/assignGroupRole', { id: id.value, data }).then((response) => {
        if (response.status === 200) {
          getGroupRole()
          loadingTable.value = false;
        } else {
          loadingTable.value = false;
        }
      });
    };
    const removeRoleGroup = (row) => {
      loadingTable.value = true;
      const data = {
        group_id: id.value,
        role_id: row.role_id,
        action: 'remove',
      }
      store.dispatch('groups/assignGroupRole', { id: id.value, data }).then((res) => {
        if (res.status === 200) {
          getGroupRole();
          loadingTable.value = false;
        } else {
          loadingTable.value = false;
        }
      })
    }

    const resolveGroupName = () => (groupData.value ? groupData.value.name : '')
    const resolveRoleName = (roleId) => {
      if (roleOptions.value.length) {
        const item = roleOptions.value.find((v) => v.id === roleId)
        return item ? item.name : ''
      }
      return '';
    }

    if (id) {
      loading.value = true
      fetchGroupData()
      fetchRole()
      getGroupRole()
    }

    return {
      loading,
      loadingTable,
      tableColumns,
      groupData,
      roleOptions,
      assignRoleData,
      assignGroupRole,
      formGroupAssign,
      roleGroupItems,
      resolveGroupName,
      resolveRoleName,
      removeRoleGroup,
    };
  },
  mounted() { },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
